export default __webpack_public_path__ + "static/media/icon-bulb.c8684f90.svg";